import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import ChangePassword from "./ChangePassword";
import ChangeUsername from "./ChangeUsername";

// ✅ Correct MUI icons
import LockReset from "@mui/icons-material/LockReset";
import Person from "@mui/icons-material/Person";
import CustomSimpleAccordion from "qubCommon/Accordions/CustomSimpleAccordion";
import { useSelector } from "react-redux";

const UserSettings = () => {
    const { user } = useSelector(state => state.auth);

    return (
        <Box
            sx={{
                maxWidth: 700,
                mx: "auto",
                mt: 6,
                minHeight: "70vh",   // ✅ requested
                marginBottom: 8,    // ✅ requested
            }}
        >
            <Typography variant="h5" fontWeight={700} mb={3}>
                Ρυθμίσεις Χρήστη
            </Typography>
            <Stack spacing={2}>
                {/* ✅ ΑΛΛΑΓΗ ΚΩΔΙΚΟΥ */}
                {user?.canChangePassword &&
                    <CustomSimpleAccordion
                        title={
                            <Stack direction="row" gap={1} alignItems="center">
                                <LockReset
                                    color="primary"
                                    fontSize="small"
                                    sx={{ marginLeft: "2px" }}
                                />

                                <Typography color="primary" sx={{ fontWeight: 1000 }}>
                                    ΑΛΛΑΓΗ ΚΩΔΙΚΟΥ ΠΡΟΣΒΑΣΗΣ
                                </Typography>
                            </Stack>
                        }
                        content={<ChangePassword />}
                    />
                }
                {/* ✅ ΑΛΛΑΓΗ USERNAME */}
                {user?.canChangeUsername &&

                    < CustomSimpleAccordion
                        title={
                            <Stack direction="row" gap={1} alignItems="center">
                                <Person
                                    color="primary"
                                    fontSize="small"
                                    sx={{ marginLeft: "2px" }}
                                />

                                <Typography color="primary" sx={{ fontWeight: 1000 }}>
                                    ΑΛΛΑΓΗ USERNAME
                                </Typography>
                            </Stack>
                        }
                        content={<ChangeUsername />}
                    />}
            </Stack>
        </Box>
    );
};

export default UserSettings;
